import CalculatorSimpleView from './CalculatorSimpleView'

export default CalculatorSimpleView
